<template>
  <KeywordListModal
    v-if="isMd"
    v-bind="$attrs"
    :lists
    :snapshot="snapshot"
    :actor="actorRef"
    :is-loading
    :is-deleting
    :lists-loading
    :is-dragging
    :last-active-list-id
  />
  <KeywordListMobile
    v-else
    v-bind="$attrs"
    :lists
    :snapshot="snapshot"
    :actor="actorRef"
    :is-loading
    :is-deleting
    :lists-loading
    :last-active-list-id
  />
</template>

<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core';
import { useActor } from '@xstate/vue';
import { groupBy } from 'lodash';
import { storeToRefs } from 'pinia';
import { computed, onMounted, onUnmounted, ref } from 'vue';

import KeywordListMobile from '@/common/components/organisms/KeywordListMobile';
import KeywordListModal from '@/common/components/organisms/KeywordListModal';
import keywordListMachine from '@/common/machines/keywordlists';
import { useKeywordListStore } from '@/common/stores/lists';

defineOptions({
  inheritAttrs: false,
});

const keywordListStore = useKeywordListStore();
const {
  loading,
  lists: listData,
  loadingKeywordsList,
  keywordsList,
  removingList,
  removingKeywordFromList,
  lastActiveListId,
  listsLoading,
} = storeToRefs(keywordListStore);

let intervalId;

const { getLists,  getKeywordsList } = keywordListStore;
const { actorRef, snapshot, send } = useActor(keywordListMachine);

const isMd = useMediaQuery('((min-width: 768px))');

const lists = computed(() => {
  if (loading.value || loadingKeywordsList.value) return [];

  const keywordsListGroup = groupBy<{ listId: number, id: number, keyword: string }>(keywordsList.value, 'listId');

  const result = listData.value.map(({ id, name }) => ({
    id,
    name,
    color: 'var(--v3-button-secondarybuttonbg)',
    keywords: keywordsListGroup[id] || [],
  }));

  return result;
});

const isDragging = ref<boolean>(false);

const isLoading = computed<boolean>(() => loading.value || loadingKeywordsList.value);
const isDeleting = computed<boolean>(() => removingList.value || removingKeywordFromList.value);

onMounted(() => {
  getLists();
  getKeywordsList();
});

onMounted(() => {
  intervalId = setInterval(() => {
    const draggingKeyword = window.DRAGGING_KEYWORD;
    
    if (draggingKeyword) {
      if (!isDragging.value) {
        isDragging.value = true;
        send({ type: 'start_dragging', keyword: draggingKeyword });
      }
    } else {
      if (isDragging.value) {
        isDragging.value = false;
        send({ type: 'end_dragging' });
      }
    }
  }, 200);
});

onUnmounted(() => clearInterval(intervalId));
</script>

<style scoped>
/* Add your styles here */
</style>
